/*
  Cart guard per pattern add-on personalizzazione.
  Invarianti enforzate (eseguite a ogni cart:updated + 1 volta a init):
    1. addon orfano (_parent_sku punta a sku non più nel cart) → rimosso
    2. base con properties personalizzazione MA senza addon → properties personalizzazione rimosse dal base
    3. qty(addon) === qty(base) sempre

  Cosmetics (eseguiti dopo enforce, a ogni cart:updated/cart:added e DOMContentLoaded):
    - Nasconde la riga DOM dell'addon (id="CartItem-N" / "CartDrawer-Item-N" all'indice corretto)
    - Inserisce una nota "+€X personalizzazione" sotto il base item linkato

  Compatibile con cart page Dawn standard + cart drawer + altre app che usano gli id CartItem-/CartDrawer-Item-.
*/
(function () {
  'use strict';

  // Keys properties personalizzazione. Le chiavi reali dipendono dal template
  // engraving del prodotto (funnel-product usa `f.key || f.label`), quindi
  // cambiano da evento a evento: Enotirino usa riga1/riga2, Maratonina usava
  // "Nome e cognome"/"Tempo gara". Sorgente: window.LZ_CONFIG.engravingPropertyKeys,
  // popolato da funnel-cart-bar.liquid dal setting lz_engraving_property_keys.
  // Fallback: unione delle chiavi note, così il guard resta attivo anche se il
  // bridge non ha ancora caricato.
  var FALLBACK_PERSO_KEYS = ['riga1', 'riga2', 'Nome e cognome', 'Tempo gara', 'Frase incisa'];
  function persoPropertyKeys() {
    var cfg = window.LZ_CONFIG && window.LZ_CONFIG.engravingPropertyKeys;
    return (cfg && cfg.length) ? cfg : FALLBACK_PERSO_KEYS;
  }
  var GUARD_FLAG = '__lzCartGuardRunning';
  var COSMETIC_FLAG = '__lzAddonHidden';
  var DEBOUNCE_MS = 200;
  var debounceTimer = null;

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function updateLine(line, payload) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(Object.assign({ line: line }, payload))
    }).then(function (r) { return r.json(); });
  }
  function hasPersoProps(item) {
    if (!item.properties) return false;
    var keys = persoPropertyKeys();
    for (var i = 0; i < keys.length; i++) {
      if (item.properties[keys[i]]) return true;
    }
    return false;
  }
  function isAddonItem(item) {
    return !!(item.properties && item.properties._parent_sku);
  }

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney && window.Shopify.shop && window.Shopify.shop.money_format) {
      return window.Shopify.formatMoney(cents, window.Shopify.shop.money_format);
    }
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  // ─── Enforce invariants ──────────────────────────────────────────────
  function enforce() {
    if (window[GUARD_FLAG]) return Promise.resolve();
    window[GUARD_FLAG] = true;
    var changed = false;

    return fetchCart()
      .then(function (cart) {
        var items = cart.items;
        // line index Shopify è 1-based, ricalcolato dopo ogni change (gli indici si spostano)

        // INV 1: addon orfano → rimuovi
        var bySku = {};
        items.forEach(function (it) { if (it.sku && !isAddonItem(it)) bySku[it.sku] = it; });
        var orphanPromise = Promise.resolve();
        for (var i = 0; i < items.length; i++) {
          var it = items[i];
          if (isAddonItem(it) && !bySku[it.properties._parent_sku]) {
            (function (line) {
              orphanPromise = orphanPromise.then(function () { changed = true; return updateLine(line, { quantity: 0 }); });
            })(i + 1);
          }
        }
        return orphanPromise.then(function () { return changed ? fetchCart() : cart; });
      })
      .then(function (cart) {
        var items = cart.items;
        // INV 2: base con perso props MA senza addon associato → rimuovi le perso props dal base
        var addonsBySku = {};
        items.forEach(function (it) { if (isAddonItem(it)) addonsBySku[it.properties._parent_sku] = it; });

        var propsPromise = Promise.resolve();
        for (var j = 0; j < items.length; j++) {
          var it = items[j];
          if (isAddonItem(it)) continue;
          if (!hasPersoProps(it)) continue;
          if (addonsBySku[it.sku]) continue; // ha addon → ok
          (function (line, item) {
            var clean = {};
            var persoKeys = persoPropertyKeys();
            Object.keys(item.properties || {}).forEach(function (k) {
              if (persoKeys.indexOf(k) === -1) clean[k] = item.properties[k];
            });
            propsPromise = propsPromise.then(function () { changed = true; return updateLine(line, { properties: clean }); });
          })(j + 1, it);
        }
        return propsPromise.then(function () { return changed ? fetchCart() : cart; });
      })
      .then(function (cart) {
        var items = cart.items;
        // INV 3: qty addon == qty base
        var bySku = {};
        items.forEach(function (it) { if (it.sku && !isAddonItem(it)) bySku[it.sku] = it; });

        var qtyPromise = Promise.resolve();
        for (var k = 0; k < items.length; k++) {
          var it = items[k];
          if (!isAddonItem(it)) continue;
          var base = bySku[it.properties._parent_sku];
          if (!base) continue;
          if (base.quantity === it.quantity) continue;
          (function (line, baseQty) {
            qtyPromise = qtyPromise.then(function () { changed = true; return updateLine(line, { quantity: baseQty }); });
          })(k + 1, base.quantity);
        }
        return qtyPromise.then(function () { return changed ? fetchCart() : cart; });
      })
      .then(function (finalCart) {
        document.dispatchEvent(new CustomEvent('cart:guard-applied', { detail: { cart: finalCart, changed: changed } }));
        return finalCart;
      })
      .catch(function (e) {
        console.warn('[lz-cart-guard] enforce failed', e);
        return null;
      })
      .then(function (finalCart) {
        window[GUARD_FLAG] = false;
        return finalCart;
      });
  }

  // ─── Cosmetics: hide addon row + inject inline note ──────────────────
  function applyCosmetics(cart) {
    if (!cart || !cart.items) return;
    var items = cart.items;
    // Trova DOM rows: Dawn cart uses #CartItem-N (cart page) e #CartDrawer-Item-N (drawer)
    items.forEach(function (item, idx) {
      var line = idx + 1;
      var rowSelectors = [
        '#CartItem-' + line,
        '#CartDrawer-Item-' + line,
        '[data-cart-item][data-line="' + line + '"]'
      ];
      var row = null;
      for (var s = 0; s < rowSelectors.length; s++) {
        row = document.querySelector(rowSelectors[s]);
        if (row) break;
      }
      if (!row) return;

      if (isAddonItem(item)) {
        // Nascondi riga addon
        row.style.display = 'none';
        row.setAttribute(COSMETIC_FLAG, '1');
      } else {
        // Pulisci eventuali hide precedenti (item non più addon)
        if (row.hasAttribute(COSMETIC_FLAG)) {
          row.style.display = '';
          row.removeAttribute(COSMETIC_FLAG);
        }
      }
    });

    // Per ogni base item che ha un addon associato → inietta nota inline
    var addonsBySku = {};
    items.forEach(function (it) { if (isAddonItem(it)) addonsBySku[it.properties._parent_sku] = it; });

    items.forEach(function (item, idx) {
      if (isAddonItem(item)) return;
      var line = idx + 1;
      var rowSelectors = ['#CartItem-' + line, '#CartDrawer-Item-' + line];
      var row = null;
      for (var s = 0; s < rowSelectors.length; s++) {
        row = document.querySelector(rowSelectors[s]);
        if (row) break;
      }
      if (!row) return;

      // Cleanup nota esistente (per re-render dopo qty change ecc.)
      var existing = row.querySelector('.lz-addon-note');
      if (existing) existing.remove();

      var addon = addonsBySku[item.sku];
      if (!addon) return;
      var note = document.createElement('div');
      note.className = 'lz-addon-note product-option';
      note.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="vertical-align:-2px;margin-right:4px"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>' +
        '<strong>+' + formatMoney(addon.line_price) + '</strong> personalizzazione';

      // Cerca elemento "details" del cart Dawn standard, fallback su row stesso
      var detailsCell = row.querySelector('.cart-item__details') || row;
      detailsCell.appendChild(note);
    });
  }

  // ─── Init + listeners ────────────────────────────────────────────────
  function runGuardAndCosmetics() {
    return enforce().then(function (finalCart) {
      // Se enforce non ha cambiato nulla restituisce il cart letto; altrimenti il cart aggiornato.
      // Per cosmetics necessitiamo del cart finale; refetch defensive.
      return finalCart || fetchCart();
    }).then(applyCosmetics);
  }

  function scheduledRun() {
    // Sopprime guard durante buy-now flow: la PDP sta per navigare a /checkout,
    // /cart/*.js paralleli aumentano solo il bot-score Cloudflare senza utilità.
    if (window.__lzBuyNowInFlight) return;
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(runGuardAndCosmetics, DEBOUNCE_MS);
  }

  document.addEventListener('cart:updated', scheduledRun);
  document.addEventListener('cart:added', scheduledRun);
  document.addEventListener('cart:guard-applied', function () { /* no-op, evita loop */ });

  // Re-applica cosmetics quando il drawer viene aperto (Dawn lo lazy-renderizza)
  document.addEventListener('click', function (e) {
    if (window.__lzBuyNowInFlight) return;
    if (e.target.closest('[data-cart-icon-bubble], [data-cart-drawer-toggle], .header__icon--cart, a[href="#cart"]')) {
      setTimeout(runGuardAndCosmetics, 350); // dopo l'animazione di apertura
    }
  });

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runGuardAndCosmetics, { once: true });
  } else {
    runGuardAndCosmetics();
  }
})();
